import { useEffect } from 'react';

import { useCliente } from '../../chat/contexto';
import { usePreferencias } from '../../chat/preferencias';

/**
 * "Ficar Ausente depois de" (U6): sem mexer no computador por esse tempo,
 * esta sessão avisa que está parada (o status escolhido não muda; a pessoa
 * aparece Ausente se todas as sessões estão paradas). Mexeu, volta.
 */
export function useAusenteAutomatico() {
  const cliente = useCliente();
  const minutos = usePreferencias((estado) => estado.ausenteApos);
  useEffect(() => {
    if (!minutos) return;
    let parado = false;
    let ultimo = Date.now();
    const mexeu = () => {
      ultimo = Date.now();
      if (parado) {
        parado = false;
        cliente.setAfk(false);
      }
    };
    const conferir = window.setInterval(() => {
      if (!parado && Date.now() - ultimo >= minutos * 60_000) {
        parado = true;
        cliente.setAfk(true);
      }
    }, 30_000);
    const eventos = [
      'pointermove',
      'keydown',
      'pointerdown',
      'wheel',
      'focus',
    ] as const;
    for (const nome of eventos)
      window.addEventListener(nome, mexeu, { passive: true });
    return () => {
      window.clearInterval(conferir);
      for (const nome of eventos) window.removeEventListener(nome, mexeu);
      if (parado) cliente.setAfk(false);
    };
  }, [cliente, minutos]);
}
